import { inventory_servie } from "../server/request";

export const getVendorsData = async (catererId) => {
    try {
        let url = `/vendor/all/${catererId}`;

        const resp = await inventory_servie({
            method: 'GET',
            url: url
        });
        if (resp.status === 200) {
            return { success: true, data: resp.data.Vendors || [] };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.errorMessage }
    }
}
export const getActiveVendors = async (catererId) => {
    try {
        let url = `vendor/active/${catererId}`;

        const resp = await inventory_servie({
            method: 'GET',
            url: url
        });
        if (resp.status === 200) {
            return { success: true, data: resp.data.vendors || [] };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.errorMessage }
    }
}
export const addNewVendorRec = async (req) => {
    const { catererId } = req;
    try {
        let url = `/vendor/${catererId}`;
        const resp = await inventory_servie({
            method: 'POST',
            data: req,
            url: url
        });
        if (resp.status == 201) {
            return { success: true, data: resp.data };
        } else {
            return { error: true, errorMessage: resp.data };
        }
    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage }
    }
}
export const saveVendor = async (req) => {
    const { id } = req;
    try {
        const url = `/vendor/${id}`;
        const resp = await inventory_servie({
            method: 'PUT',
            data: req,
            url: url
        });
        if (resp.status == 200) {
            return { success: true, data: resp.data };
        } else {
            return { error: true, errorMessage: resp.data };
        }

    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.message;
        return { error: true, errorMessage: errorMessage };
    }
}
export const deleteVendorRecord = async (id) => {
    try {
        const url = `/vendor/ ${id}`;
        const resp = await inventory_servie({
            method: 'DELETE',
            url: url
        });
        if (resp.status == 200) {
            return { success: true, data: { ...resp, message: resp.data || '' } };
        } else {
            return { error: true, errorMessage: resp.data };
        }

    } catch (ex) {
        const errorObject = ex;
        const errorMessage = errorObject.error;
        return { error: true, errorMessage: errorMessage };
    }
}